module.exports = __webpack_public_path__ + "f3f8a65326d39f773271a80fa9f12dd7.pdf";